import { App } from '@capacitor/app';
import { Component } from '@angular/core';
import { Device } from '@capacitor/device';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-info',
  standalone: false,
  styleUrls: ['./app-info.component.scss'],
  templateUrl: './app-info.component.html',
})
export class AppInfoComponent {
  public name: string = 'Not set';
  public id: string = 'Not set';
  public version: string = 'Not set';
  public build: string = 'Not set';
  public device: string = 'Not set';
  public os: string = 'Not set';
  public environment: string = 'Not set';

  constructor() {
    this.getAppInfo().catch();
  }

  private async getAppInfo(): Promise<void> {
    try {
      const appInfo = await App.getInfo();
      const deviceInfo = await Device.getInfo();

      this.name = appInfo.name;
      this.id = appInfo.id;
      this.version = appInfo.version;
      this.build = appInfo.build;
      this.device = `${deviceInfo.manufacturer} ${deviceInfo.model}`;
      this.os = `${deviceInfo.operatingSystem} ${deviceInfo.osVersion}`;
    } catch (error) {
      console.error('app-info data: ', error.message);
    }

    this.environment = environment.name;
  }
}
